export default "__VITE_ASSET__B6OXwMLL__"